module.exports = __webpack_public_path__ + "smid.jpg?59f8247f47eaf55958225e4c0b184aa4";